/**
 * Wordle-style shareable result for the Front Page Quiz.
 *
 * The GTM research is unambiguous: the single strongest zero-dollar reach play is a
 * daily game whose RESULT is a paste-anywhere text block (the Wordle loop). The game
 * already shares a challenge link; this gives the quiz the same muscle. Pure module,
 * no DOM, so the text is unit-testable.
 *
 * House style: no em dashes anywhere, use middle dots and commas.
 */

/** One green/red square per question, in the order they were answered. */
export function quizResultGrid(results: boolean[]): string {
  return results.map((r) => (r ? "\u{1F7E9}" : "\u{1F7E5}")).join("");
}

/**
 * The full share block:
 *
 *   InSnip Front Page Quiz · Fri 1 Aug
 *   🟩🟩🟥🟩🟩 4/5
 *   Play today's: https://insnip.com/read#quiz
 */
export function quizShareText(results: boolean[], dayLabel: string, url: string): string {
  const score = results.filter(Boolean).length;
  return [
    `InSnip Front Page Quiz · ${dayLabel}`,
    `${quizResultGrid(results)} ${score}/${results.length}`,
    `Play today's: ${url}`,
  ].join("\n");
}

/** #quiz (optionally #quiz=...) opens today's quiz, mirroring wantsGameFromHash. */
export function wantsQuizFromHash(hash: string | undefined | null): boolean {
  if (!hash) return false;
  return /^#quiz(\b|=|$)/i.test(hash.trim());
}
